import React from 'react';
import './index.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Process from './components/Process';
import Verticals from './components/Verticals';
import Pricing from './components/Pricing';
import Portfolio from './components/Portfolio';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function App() {
  return (
    <>
      <Navbar />
      <Hero />
      <Process />
      <Verticals />
      <Pricing />
      <Portfolio />
      <Contact />
      <Footer />
    </>
  );
}
